import styled from 'styled-components';
const FixedWidthEnrollmentFilterWithDetailsWrapper = styled.div.withConfig({
  displayName: "FixedWidthEnrollmentFilterWithDetailsWrapper",
  componentId: "sc-18lkxrg-0"
})(["width:425px;"]);
export default FixedWidthEnrollmentFilterWithDetailsWrapper;